import { Check } from 'lucide-react';

/**
 * Checkbox-style "Mark as done" toggle for self-attested wins (NEA-5765).
 * Controlled — the parent persists via useLocalPotentialActions.
 */
export function MarkAsDoneButton({ activated, onToggle }) {
	return (
		<button
			type="button"
			onClick={onToggle}
			aria-pressed={activated}
			aria-label={activated ? 'Mark as not done' : 'Mark as done'}
			className="group inline-flex shrink-0 items-center gap-2 rounded-full border border-border bg-white px-4 py-2 transition hover:bg-accent"
		>
			<span
				className={`flex h-5 w-5 items-center justify-center rounded-md transition ${
					activated ? 'bg-success' : 'border-2 border-border group-hover:border-foreground'
				}`}
			>
				{activated ? <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} /> : null}
			</span>
			<span
				className={`text-sm transition ${activated ? 'font-medium text-success' : 'text-muted-foreground group-hover:text-foreground'}`}
			>
				{activated ? 'Done' : 'Mark as done'}
			</span>
		</button>
	);
}
